import type {LoaderFunctionArgs} from 'react-router'

import type {BuildTypeId} from '../../../types'
import {BuildPageTabNamesEnum} from '../../../types'
import type {ThinNestedEntryPointParamsObject} from '../../../types/entryPoints'
import {queryToObject} from '../../../utils/queryParams'

import {BuildArtifactsTabEntryPoint} from './BuildArtifactsTab/BuildArtifactsTab.entryPoint'
import {BuildChangesTabEntryPoint} from './BuildChangesTab/BuildChangesTab.entryPoint'
import {BuildOverviewTabEntryPoint} from './BuildOverviewTab/BuildOverviewTab.entryPoint'
import type {BuildTabsEntryPoints} from './BuildPage.container'
import {BuildParametersTabEntryPoint} from './BuildParametersTab/BuildParametersTab.entryPoint'
import {BuildTestsTabEntryPoint} from './BuildTestsTab/BuildTestsTab.entryPoint'
import {DependenciesTabEntryPoint} from './DependenciesTab/DependenciesTab.entryPoint'

export function getBuildTabsEntryPoints({
  arg,
  buildLocator,
  buildTab,
  buildTypeId,
  isPipeline,
}: {
  arg: LoaderFunctionArgs
  buildLocator: string
  buildTab?: string | null
  buildTypeId?: BuildTypeId
  isPipeline?: boolean
}) {
  const url = new URL(arg.request.url)
  const {buildParametersTab} = queryToObject(url.search)
  const entryPoints: ThinNestedEntryPointParamsObject<BuildTabsEntryPoints> = {}
  switch (buildTab) {
    case BuildPageTabNamesEnum.DEPENDENCIES:
      if (buildTypeId != null && !isPipeline) {
        entryPoints.dependenciesTab = {
          entryPoint: DependenciesTabEntryPoint,
          entryPointParams: {buildTypeId, buildLocator},
        }
      }
      break
    case BuildPageTabNamesEnum.TESTS:
      entryPoints.testsTab = {
        entryPoint: BuildTestsTabEntryPoint,
        entryPointParams: {
          ...arg,
          context: {
            buildLocator,
          },
        },
      }
      break
    case BuildPageTabNamesEnum.PARAMETERS:
      entryPoints.parametersTab = {
        entryPoint: BuildParametersTabEntryPoint,
        entryPointParams: {buildLocator, buildParametersTab},
      }
      break
    case BuildPageTabNamesEnum.ARTIFACTS:
      entryPoints.artifactsTab = {
        entryPoint: BuildArtifactsTabEntryPoint,
        entryPointParams: buildLocator,
      }
      break
    case BuildPageTabNamesEnum.CHANGES:
      entryPoints.changesTab = {
        entryPoint: BuildChangesTabEntryPoint,
        entryPointParams: buildLocator,
      }
      break
    case BuildPageTabNamesEnum.OVERVIEW:
    default:
      entryPoints.overviewTab = {
        entryPoint: BuildOverviewTabEntryPoint,
        entryPointParams: buildLocator,
      }
  }
  return entryPoints
}
